// Deliberately a leaf module with no other imports: config.guest.ts pulls only constants from each
// component to keep the guest metadata registry lightweight.
// Versioned filename because the CDN serves these immutably (max-age=604800). Both earlier versions
// are superseded and must not be used: v1_0_1 declared `format: "uri"`, which event_service's bare
// `new Ajv()` cannot compile, so every write against it failed; v1_0_2 replaced that with a
// maxLength the shared form cannot enforce (a capped field renders a character counter, which this
// design does not have), so an over-long paste would have failed the whole write with a generic
// error. This version constrains no string length. See PageSchedule.schema.spec.ts.
export const PAGE_SCHEDULE_SCHEMA_URL = 'https://withjoy.com/assets/public/schemas/pageScheduleSchemaV1_0_3.json' as const;
export const PAGE_SCHEDULE_COMPONENT_TYPE = 'PageSchedule' as const;
